import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportPermissaoAcessoUseCase } from "../../../presentation/useCases/read/get_report_permissao_acesso_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportPermissaoAcessoUseCase
 */

export class GetReportPermissaoAcessoUseCase implements IGetReportPermissaoAcessoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(requiredMimeType: ReportMimeType | null): Promise<ReportData> {
    const response = await this.repository.getReportPermissaoAcesso(requiredMimeType);

    if (response.mimeType !== "text/html") {
      const arquivoData = response.bytes;
      const arquivoNome = `permissao_acesso_${new Date().toISOString()}.${response.filenameExtension}`

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }

}
